module.exports = __webpack_public_path__ + "static/media/Alakazam_gaussian2.32fdcc85.png";